var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGridiconsDelivered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 16c0 7.279 5.921 13.2 13.2 13.2 7.279 0 13.2-5.921 13.2-13.2 0-7.279-5.921-13.2-13.2-13.2C8.721 2.8 2.8 8.721 2.8 16zm2.025 0C4.825 9.838 9.838 4.825 16 4.825c6.162 0 11.175 5.013 11.175 11.175 0 6.162-5.013 11.175-11.175 11.175-6.162 0-11.175-5.013-11.175-11.175z",
    fill: "#83D128",
    stroke: "#83D128",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.781 20.333a.806.806 0 01-.574-.238l-3.521-3.52a.813.813 0 011.15-1.15l2.946 2.947 6.468-6.468a.813.813 0 111.149 1.15l-7.042 7.041a.814.814 0 01-.576.238z",
    fill: "#83D128"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridiconsDelivered);
export default __webpack_public_path__ + "static/media/gridicons_delivered.fab18e0101790dae4c883ff968fa46c7.svg";
export { ForwardRef as ReactComponent };